import { PurchaseOrderContractTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 0821. 発注案件契約タスク計画金額最新化済更新
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_contract_tasks/:id/update_payment_schedule_checked
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  payment_schedule_checked: boolean;
};

const updatePurchaseOrderContractPaymentScheduleChecked = (props: Props): Promise<PurchaseOrderContractTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_contract_tasks/${props.id}/update_payment_schedule_checked`,
    props
  );
};

export const useUpdatePurchaseOrderContractPaymentScheduleChecked = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderContractPaymentScheduleChecked,
  });
};
